<template>
  <el-dialog
    title="新增风险设备"
    :close-on-click-modal="false"
    top="120px"
    append-to-body
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-form label-width="120px" ref="deviceForm" :model="riskForm" :rules="rules"
    >
      <el-form-item label="渠道+UID" prop="appid">
        <div style="margin-bottom: 10px" >
          <el-input class="inputs" placeholder="请选择渠道（单选）"  @focus="handleClickChannel()" type="textarea" v-model="riskForm.appid"></el-input>
        </div>
      </el-form-item>
      <el-form-item label=" " prop="uid" >
        <el-input class="inputs" placeholder="请输入UID" v-model="riskForm.uid" clearable></el-input>
      </el-form-item>
      <el-form-item label="Mac 地址" prop="mac">
        <el-input class="inputs" placeholder="请输入Mac地址" v-model="riskForm.mac" clearable></el-input>
      </el-form-item>
      <el-form-item label="AndroidID" prop="androidId">
        <el-input class="inputs" placeholder="请输入AndroidID" v-model="riskForm.androidId" clearable></el-input>
      </el-form-item>
      <el-form-item label="IDFA" prop="idfa">
        <el-input class="inputs" placeholder="请输入IDFA" v-model="riskForm.idfa" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input class="inputs" placeholder="请输入手机号"  v-model="riskForm.phone" clearable></el-input>
      </el-form-item>
      <el-form-item label="风险等级" prop="level">
        <div class="radio-wrapper">
          <el-radio-group v-model="riskForm.level">
            <el-radio v-for="item in riskLevel" style="display: block" :label="item.level" :key="item.label">
              {{item.key}}
              <div class="info">{{item.text}}</div>
            </el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input class="inputs"
                type="textarea"
                maxlength="500"
                placeholder="备注内容"
                v-model="riskForm.remark"
                clearable
              ></el-input>
      </el-form-item>
    </el-form>
    <channel-popups :visible.sync="showPopups" :app-id="scopeAppId" :isRabbittactics="true"
                        @comfirm="handleConfirm"></channel-popups>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSave">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ChannelPopups from '@/components/channel-popups';
import { merge } from "@/util/common";
import { submitRiskDevice } from "@/api/security/riskDevices.js";
export default {
  props: {
    riskLevel: Object
  },
  components: {
    ChannelPopups
  },
  data() {
    return {
      riskForm: {
        appid: '',
        uid: '',
        mac: '',
        androidId: '',
        idfa: '',
        phone: '',
        level: '',
        remark: ''
      },
      scopeAppId: '',
      showPopups: false,
      rules: {
        appid: [{
          validator: (rule, value, callback) => {
            if( this.riskForm.uid === '' || this.riskForm.uid === undefined || this.riskForm.uid === null) {
              callback(new Error('请输入uid对应的appid'));
            } else {
              callback();
            }
        }, trigger: 'blur',required: true}],
        uid: [{
          validator: (rule, value, callback) => {
            if( this.riskForm.appid === ''|| this.riskForm.appid === undefined || this.riskForm.appid === null) {
              callback(new Error('请输入appid对应的id!'));
            } else {
              callback();
            }
        }, trigger: 'blur',required: true}],
        level: [{ required: true, message: "请选择风险等级", trigger: "change" }]
      }
    };
  },
  watch: {
    "$attrs.visible"(nVal) {
      if(!nVal) {
        this.$refs.deviceForm.resetFields()
      }
    }
  },
  methods: {
    onSave() {
      this.$refs.deviceForm.validate(valid => {
        if(valid) {
          // 渠道+UID、Mac地址、androidID、IDFA、手机号、5 个需至少填写一个
          const {appid, mac, androidId, idfa, phone} = this.riskForm
          const arrs = [appid, mac, androidId, idfa, phone]
          const isValid = arrs.some(item => item !== '')
          if(isValid) {
            console.log('校验通过')
            this.saveLoading = true
            let saveData = merge({}, this.riskForm)
            // 手动录入要传 0
            saveData.enterType = 0
            submitRiskDevice(saveData).then(res => {
              console.log(res)
              this.saveLoading = false
              this.$emit("update:visible", false);
              this.$emit("reload")
            }).catch( err => {
              this.saveLoading = false
              console.log(err)
            })
          } else {
            this.$message.warning("渠道+UID、Mac地址、androidID、IDFA、手机号、5个需至少填写一个，才可以保存！");
          }
        } else {
          console.log("参数较验失败")
          return false
        }
      })
    },
    cancel() {
      console.log('取消')
      this.$refs.deviceForm.resetFields()
      this.$emit("update:visible", false)
    },
    handleClickChannel() {
      console.log(this.riskForm)
      this.showPopups = true
    },
    handleConfirm(res) {
      console.log(res)
      // this.riskForm.channel = res.channel
      this.riskForm.appid = res.appId
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-card__header {
  background: #f5f7fa;
}
.info {
  color: #ccc;
}
.card-header {
  height: 40px;
  line-height: 40px;
}

.inputs {
  width: 80%;
}
.radio-wrapper {
  padding-top: 10px;
  .el-radio {
    margin-bottom: 10px;
  }
}
</style>
